const getAiUrl = (baseUrl: string, queryKey: string, prompt: string) => {
  const url = new URL(baseUrl);
  url.searchParams.set(queryKey, prompt);
  return url.toString();
};

export default getAiUrl;
